export default __webpack_public_path__ + "static/media/igud_yeshivos_icon_clear_background.a38f38d3.png";